<template id="sales-man-drilldown">
    <section>
        <div class="row">
            <div class="col-md-10 col-lg-12 text-center mt-3 mb-5">
                <div class="card">
                    <div class="card-header text-left">
                        Salesman Performance
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover">
                                <thead class="thead-dark">
                                <tr>
                                    <th></th>
                                    <th>Sales Man</th>
                                    <th>Transactions</th>
                                    <th>Sales Amount</th>
                                    <th>Margin</th>
                                    <th>Margin%</th>
                                    <th>Actions</th>
                                    <th>Assign</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(s,idx) in salesManData">
                                    <tr v-bind:key="idx">
                                        <td><a @click="loadLevelOne(s.name)"><span class="offset-md-0">+</span></a></td>
                                        <td>{{s.name}}</td>
                                        <td class="text-right">{{s.txns}}</td>
                                        <td class="text-right">{{s.txnamt}}</td>
                                        <td class="text-right">{{s.txnamt-s.cstamt}}</td>
                                        <td class="text-right">{{(((s.txnamt-s.cstamt)*100)/s.txnamt).toFixed(2)}}</td>
                                        <td>
                                            <a @click="commentBox('Retailer Drilldown', 'drilldown_report')">
                                                <i class="fa fa-tags text-primary"></i>
                                            </a>
                                            <a @click="assignModal('retailer_view', p.retailer_id)">
                                                <i class="fa fa-user-cog text-info"></i>
                                            </a>
                                        </td>
                                        <td>
                                            <span v-if="s.assign==null">- NA -</span>
                                            <span v-if="s.assign!=null">{{s.assign}}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="whatL1 === s.name" class="table-info" v-bind:key="`s-${idx}`">
                                        <th></th>
                                        <th><span class="offset-md-1">Product Category</span></th>
                                        <th>Transaction</th>
                                        <th>Sale Amount</th>
                                        <th>Margin</th>
                                        <th>Margin%</th>
                                        <th>Action</th>
                                        <th>Assign</th>
                                    </tr>
                                    <template v-for="(s1,idx) of l1Data">
                                        <tr v-bind:key="`s1-${idx}`" v-if="whatL1 === s.name">
                                            <td>
                                                <a href="#" @click="loadLevelTwo(s1.name, s1.brand)">
                                                    <span class="offset-md-1">&gt;&gt;</span>
                                                </a>
                                            </td>
                                            <td><span class="offset-md-1" v-b-tooltip.hover
                                                      title="Sub Category">{{s1.brand}}</span>
                                            </td>
                                            <td class="text-right"><span
                                                    v-b-tooltip.hover title="Transaction">{{s1.txns}}</span></td>
                                            <td class="text-right"><span
                                                    v-b-tooltip.hover title="Sale Amount">{{s1.txnamt}}</span></td>
                                            <td class="text-right"><span v-b-tooltip.hover title="Margin">{{s1.txnamt-s1.cstamt}}</span>
                                            </td>
                                            <td class="text-right">
                                                <span v-b-tooltip.hover title="Margin%">{{(((s1.txnamt-s1.cstamt)*100)/s1.txnamt).toFixed(2)}}</span>
                                            </td>
                                            <td><a @click="commentBox('Retailer Drilldown', 'drilldown_report')">
                                                <i class="fa fa-tags text-primary"></i>
                                            </a>
                                                <a @click="assignModal('retailer_view', p.retailer_id)">
                                                    <i class="fa fa-user-cog text-info"></i>
                                                </a></td>
                                            <td v-b-tooltip.hover title="Assign">
                                                <span v-if="s.assign==null">- NA -</span>
                                                <span v-if="s.assign!=null">{{s.assign}}</span>
                                            </td>
                                        </tr>
                                        <tr v-if="whatL1 === s.name && whatL2 === s1.brand" class="table-primary"
                                            v-bind:key="`s2-${idx}`">
                                            <th></th>
                                            <th><span class="offset-md-2">SKU Name</span></th>
                                            <th>Transaction</th>
                                            <th>Sale Amount</th>
                                            <th>Margin</th>
                                            <th>Margin%</th>
                                            <th>Action</th>
                                            <th>Assign</th>
                                        </tr>
                                        <template v-for="(s2,idx) of l2Data">
                                            <tr class="f-s" v-bind:key="`s3-${idx}`"
                                                v-if="whatL1 === s.name && whatL2 === s1.brand">
                                                <td><span class="offset-md-3">&#8680;</span></td>
                                                <td><span class="offset-md-2">{{s2.productCategory}}</span></td>
                                                <td class="text-right">{{s2.txns}}</td>
                                                <td class="text-right">{{s2.txnamt}}</td>
                                                <td class="text-right">{{s2.txnamt-s2.cstamt}}</td>
                                                <td class="text-right">
                                                    {{(((s2.txnamt-s2.cstamt)*100)/s2.txnamt).toFixed(2)}}
                                                </td>
                                                <td><a @click="commentBox('Retailer Drilldown', 'drilldown_report')">
                                                    <i class="fa fa-tags text-primary"></i>
                                                </a>
                                                    <a @click="assignModal('retailer_view', p.retailer_id)">
                                                        <i class="fa fa-user-cog text-info"></i>
                                                    </a></td>
                                                <td>
                                                    <span v-if="s.assign==null">- NA -</span>
                                                    <span v-if="s.assign!=null">{{s.assign}}</span>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'

export default {
    name: 'sales-man-drilldown',
    data: function () {
      return {
        salesManData: [],
        whatL1: null,
        whatL2: null,
        l1Data: [],
        l2Data: []
      }
    },

    created: function () {
      this.loadSalesMan()
    },
    methods: {
      //Get Request
      loadSalesMan: function () {
        let url = '/api/salesman_view'
        axios.get(url)
          .then(res => {
            this.salesManData = res.data
          }, err => {
            console.log('Error in fetching data', err)
          })
      },
      //Get Request Level - 1 data
      loadLevelOne: function (l1) {
        if (this.whatL1 === l1) {
          this.whatL1 = null
        } else {this.whatL1 = l1}
        let url = '/api/product_category/' + l1
        axios.get(url)
          .then(res => {
            this.l1Data = res.data
          }, err => {
            console.log('Error in fetching Data', err)
          })
      },
      //Get Request Level - 2 data
      loadLevelTwo: function (l1, l2) {
        if (this.whatL2 === l2) {
          this.whatL2 = null
        } else {this.whatL2 = l2}
        let url = '/api/customer/' + l1 + '/' + l2
        axios.get(url)
          .then(res => {
            this.l2Data = res.data
          }, err => {
            console.log('Error in fetching Data', err)
          })
      }

    }//Method Ends
  }
</script>
<style>
    .f-s {
        font-style: italic;
        font-weight: bold;
    }
</style>